import _ from 'underscore'
import api from '../../libs/Api'
import constants from '../../constants'
import * as types from './types'

export default {
  namespaced: true,
  state: {
    offices: []
  },
  mutations: {
    [types.SET_OFFICES] (state, value) {
      state.offices = value
    }
  },
  actions: {
    getOffices ({ commit, state }) {
      return api.getOffice(constants.QUERY_MODE_TRIM_GET)
        .then(res => {
          commit(types.SET_OFFICES, res)
          return Promise.resolve(res)
        })
    },

    clearOffice ({ commit }) {
      commit(types.SET_OFFICES, [])
    },

    findOffice ({ commit, state }, officeId) {
      if (!state.offices || state.offices.length === 0) {
        return Promise.reject(new Error('office not found'))
      }
      return _.find(state.offices, office => {
        return office.id === officeId
      })
    }
  },
  getters: {}
}
